import { Controller } from "@hotwired/stimulus"

// Cascade instituicao -> produto no form de emitir cartao do associado.
// Quando a instituicao muda, busca produtos disponiveis para o associado
// naquela instituicao e repopula o select de produto.
export default class extends Controller {
  static targets = ["parent", "child"]
  static values = { associadoId: Number }

  filter() {
    const instituicaoId = this.parentTarget.value
    if (!instituicaoId) return

    const url = `/ac/associados/${this.associadoIdValue}?instituicao_id=${instituicaoId}&ajax=true`

    fetch(url, { headers: { "Accept": "application/json" } })
      .then((response) => response.json())
      .then((produtos) => {
        this.childTarget.innerHTML = ""
        produtos.forEach((produto) => {
          const opt = document.createElement("option")
          opt.value = produto.id
          opt.textContent = produto.nome
          this.childTarget.appendChild(opt)
        })
      })
  }
}
